import { useState, useEffect } from 'react';
import { Modal, IconButton, InputAdornment, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useToast } from 'use-toast-mui';
import { formatterCurrency } from '../../../utils/methods';
import CommonModalButton from '../../../form-components/CommonModalButton';

import {
  AdjustModalContainer,
  AdjustModalHeader,
  AdjustModalTitle,
  AdjustModalBody,
  AdjustInfoCard,
  AdjustInfoRow,
  AdjustInfoLabel,
  AdjustInfoTitle,
  AdjustAmountCard,
  AdjustAmountInput,
  AdjustMemoCard,
  AdjustMemoInput,
  AdjustModalFooter,
} from './SalarySettlementStyled';

// 수업이력 탭에서 개별 수업 1건의 "정산된 수업 수당"을 직접 수정하는 모달.
// 총액에 델타를 더하는 AdjustAmountModal과 달리, 이 건 자체의 값을 새 값으로 교체한다.
const EditLessonAllowanceModal = ({ open, onClose, lessonLabel, currentAmount, initialMemo, onSave }) => {
  const toast = useToast();
  const [amount, setAmount] = useState('');
  const [memo, setMemo] = useState('');

  useEffect(() => {
    if (open) {
      setAmount(currentAmount != null ? currentAmount.toLocaleString() : '');
      // 이미 수정한 적이 있는 건이면, 이전 수정 사유를 불러와 기본값으로 보여준다.
      setMemo(initialMemo || '');
    }
  }, [open, currentAmount, initialMemo]);

  const numericAmount = parseInt(amount?.replace(/,/g, '') || '0', 10);

  const handleAmountChange = e => {
    const raw = e.target.value.replace(/[^0-9]/g, '');
    setAmount(raw ? Number(raw).toLocaleString() : '');
  };

  const handleSave = () => {
    if (!amount) {
      toast.error('수정할 금액을 입력해주세요');
      return;
    }
    if (!memo.trim()) {
      toast.error('수정 사유를 입력해주세요');
      return;
    }
    onSave?.({ amount: numericAmount, memo: memo.trim() });
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} disableScrollLock>
      <AdjustModalContainer>
        <AdjustModalHeader>
          <AdjustModalTitle>정산 수당 수정</AdjustModalTitle>
          <IconButton onClick={onClose} sx={{ color: '#fff', p: '4px' }}>
            <Close />
          </IconButton>
        </AdjustModalHeader>

        <AdjustModalBody>
          <AdjustInfoCard>
            <AdjustInfoRow>
              <AdjustInfoLabel>수정 대상</AdjustInfoLabel>
            </AdjustInfoRow>
            <AdjustInfoTitle sx={{ mt: '4px' }}>{lessonLabel}</AdjustInfoTitle>
            <AdjustInfoRow sx={{ mt: '12px', pt: '12px', borderTop: '1px solid #f0f0f0' }}>
              <AdjustInfoLabel>현재 수당</AdjustInfoLabel>
              <Typography sx={{ fontSize: '15px', fontWeight: 600, color: '#262626' }}>
                {formatterCurrency(currentAmount)}원
              </Typography>
            </AdjustInfoRow>
          </AdjustInfoCard>

          <AdjustAmountCard>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#262626' }}>
              수정할 수당
            </Typography>
            <AdjustAmountInput
              fullWidth
              value={amount}
              onChange={handleAmountChange}
              placeholder="0"
              InputProps={{
                endAdornment: <InputAdornment position="end">원</InputAdornment>,
              }}
            />
          </AdjustAmountCard>

          <AdjustMemoCard>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#262626' }}>
              수정 사유
              {initialMemo && (
                <Typography component="span" sx={{ ml: '6px', fontSize: '12px', fontWeight: 500, color: '#8c8c8c' }}>
                  (이전 수정 사유를 불러왔습니다)
                </Typography>
              )}
            </Typography>
            <AdjustMemoInput
              fullWidth
              multiline
              rows={3}
              value={memo}
              onChange={e => setMemo(e.target.value)}
              placeholder="수정 사유를 입력해 주세요."
            />
          </AdjustMemoCard>
        </AdjustModalBody>

        <AdjustModalFooter>
          <CommonModalButton variant="cancel" onClick={onClose}>
            취소
          </CommonModalButton>
          <CommonModalButton variant="submit" onClick={handleSave}>
            저장
          </CommonModalButton>
        </AdjustModalFooter>
      </AdjustModalContainer>
    </Modal>
  );
};

export default EditLessonAllowanceModal;
